import type { Permission } from '@hv/shared';

export interface View {
  path: string;
  label: string;
  permission: Permission;
}

export const VIEWS: readonly View[] = [
  { path: '/pipeline', label: 'Pipeline', permission: 'households.read' },
  { path: '/referrals', label: 'Referrals', permission: 'referrals.review' },
  { path: '/dashboard', label: 'Dashboard', permission: 'households.read' },
  { path: '/advancement', label: 'Advancement', permission: 'households.read' },
  { path: '/duplicates', label: 'Duplicates', permission: 'duplicates.resolve' },
  { path: '/recommendation-history', label: 'Recommendation History', permission: 'referrals.review' },
  { path: '/reports', label: 'Reports', permission: 'referrals.review' },
  { path: '/my-referrals', label: 'My Referrals', permission: 'referrals.own' },
  { path: '/my-recommendations', label: 'My Recommendations', permission: 'referrals.own' },
  { path: '/my-recommendation-history', label: 'History', permission: 'referrals.own' },
  { path: '/admin', label: 'Admin', permission: 'settings.read' },
];

export function visibleViews(can: (p: Permission) => boolean): View[] {
  return VIEWS.filter((v) => can(v.permission));
}

export function homePath(can: (p: Permission) => boolean): string | null {
  return visibleViews(can)[0]?.path ?? null;
}
